import React from 'react';

function PostCardSkeleton() {
  return (
    <div className="group bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden animate-pulse">
      <div className="p-5 md:p-6">
        <div className="flex justify-between items-start gap-4 mb-4">
          <div className="flex-1 space-y-3">
            <div className="h-6 bg-slate-100 rounded-lg w-3/4" />

            <div className="flex flex-wrap items-center gap-2 mt-2">
              <div className="h-5 bg-slate-100 rounded-md w-20" />
              <div className="h-4 bg-slate-100 rounded-md w-16" />
              <div className="h-4 bg-slate-100 rounded-md w-24" />
            </div>
          </div>

          <div className="flex items-center gap-1.5 px-3 py-1 rounded-full border border-slate-100 bg-slate-50">
            <div className="h-3 w-3 rounded-full bg-slate-200" />
            <div className="h-3 w-10 rounded-full bg-slate-200" />
          </div>
        </div>

        <div className="flex items-center justify-between mt-6 pt-5 border-t border-gray-50">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-full bg-slate-100" />
            <div className="space-y-2">
              <div className="h-3 w-24 bg-slate-100 rounded" />
              <div className="h-2 w-32 bg-slate-100 rounded" />
            </div>
          </div>

          <div className="flex items-center gap-6">
            <div className="flex items-center gap-2">
              <div className="h-4 w-4 rounded-full bg-slate-100" />
              <div className="h-3 w-6 bg-slate-100 rounded" />
            </div>
            <div className="flex items-center gap-2">
              <div className="h-4 w-4 rounded-full bg-slate-100" />
              <div className="h-3 w-6 bg-slate-100 rounded" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PostCardSkeleton;

